import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { CloseCircleIcon as n, SmallPenIcon as h } from "@systemeio/ui/icons";
import { CircularProgress as v } from "../circular-progress.mjs";
import { twMerge as o } from "tailwind-merge";
import { FilePreviewFromOS as y } from "../../../../components/file-preview-from-os/index.mjs";
import { FilePreview as N } from "../../../../components/file-preview/index.mjs";
function I({
  file: e,
  progress: d = 0,
  isError: s,
  isLoading: u,
  isLoaded: k,
  isDeleting: c,
  className: m,
  disabled: a,
  disabledDeleteButton: t,
  showDeleteButton: p,
  showEditButton: f,
  onDeleteFile: b,
  onEdit: g
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: o("relative w-24 h-24", m),
      onClick: (l) => l.stopPropagation(),
      children: [
        p && /* @__PURE__ */ r(
          "button",
          {
            type: "button",
            className: o(
              "absolute group -top-2 -right-2 z-1 rounded-full bg-background-primary",
              c && "animate-pulse"
            ),
            onClick: (l) => {
              l.preventDefault(), l.stopPropagation(), b();
            },
            disabled: t || a,
            children: /* @__PURE__ */ r(
              n,
              {
                className: o(
                  "fill-text-secondary transition-colors",
                  !t && !a && "group-hover:fill-brand-primary"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ i("div", { className: "relative w-full h-full group/edit", children: [
          e instanceof File ? /* @__PURE__ */ r(y, { file: e, className: "w-full h-full rounded-md" }) : /* @__PURE__ */ r(
            N,
            {
              src: e.thumbnail || e.path,
              fileType: e.type,
              isThumbnail: !0,
              className: "w-full h-full rounded-md",
              title: e.filename
            }
          ),
          /* @__PURE__ */ r(
            "div",
            {
              className: o(
                "absolute top-0 left-0 w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md cursor-auto hidden",
                f && !a && "flex lg:hidden group-hover/edit:lg:flex"
              ),
              children: /* @__PURE__ */ r("div", { onClick: g, className: "cursor-pointer group p-2", children: /* @__PURE__ */ r(h, { className: "fill-background-secondary group-hover:fill-brand-primary transition-colors" }) })
            }
          )
        ] }),
        s && /* @__PURE__ */ r("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ r(n, { className: "fill-danger rounded-full" }) }),
        u && /* @__PURE__ */ r("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ r(v, { progress: d }) })
      ]
    }
  );
}
export {
  I as FileUploaderItem
};
